import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/style/index.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'wowjs/css/libs/animate.css'
import axios from 'axios'
import './assets/fonts/iconfont.css'

// import AMapLoader from "@amap/amap-jsapi-loader";

// AMapLoader.load({
//   'key': '1fc490590cdddb340505ccaa28298e5f',           
//   'version': '2.0',
//   'plugins': ['AMap.Scale','AMap.GeoJSON']
// }).then((AMap) => {
//   Vue.use(AMap)
// })

Vue.prototype.$axios = axios
Vue.config.productionTip = false
Vue.use(ElementUI);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
